import Swiper, { Pagination } from 'swiper';
import 'swiper/css';

window.addEventListener('load', (e) => {
	const testimonialSwipers = document.querySelectorAll(
		'.testimonials-swiper'
	);

	testimonialSwipers.forEach((testimonialSwiper) => {
		let testimonialSwipe = new Swiper(testimonialSwiper, {
			modules: [Pagination],
			slidesPerView: 1.2,
			spaceBetween: 30,
			pagination: {
				el: testimonialSwiper.querySelector('.swiper-pagination'),
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 2.2,
				},
				1100: {
					slidesPerView: 2,
				},
			},
		});
	});
});
